<template>
    <cleave class="a-input"
            :options="options"
            v-model="raw"
            @blur="onBlur"
            @keyup.native="$emit('keyup')">
    </cleave>
</template>

<script>
  import Cleave from 'vue-cleave-component'

  export default {
    name: 'input-percent',

    props: [ 'value' ],

    data: () => ({
      val: undefined
    }),

    computed: {
      options: {
        get: function() {
          return {
            numeral: true,
            delimiter: ' ',
            numeralPositiveOnly: true,
            numeralIntegerScale: 10,
            numeralDecimalScale: 2
          }
        }
      },

      raw: {
        get: function() {
          let v = this.value;
          v = _.isFinite(+v) ? +v : undefined;

          if (v === undefined) return '';
          return v / 100;
        },

        set: function(value) {
          if (value != '') {
            const parts = value.split('.').map(e => e || '0');
            if (parts.length === 1) parts.push('0');
            value = parts[0] * 100 + parts[1] * (parts[1].length == 2 ? 1 : 10);
          }
          else {
            value = undefined;
          }

          this.val = value;
          this.$emit('input', value);
        }
      }
    },

    components: { Cleave },

    methods: {
      onBlur() {
        this.$emit('change', this.val);
        this.$emit('blur');
      }
    }
  }
</script>

<style scoped>

</style>
